module.exports = __webpack_public_path__ + "files/e64c14a673d3bdcabf770455773f2b69.png";